export default __webpack_public_path__ + "static/media/cal-icn.6648e788.svg";